import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import {observer} from "mobx-react-lite";
import {useStore} from "../../../hooks/useStore";
import SettingReserv from "./setting_reserv";
import {CircularProgress} from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import {toast} from "react-toastify";

const Reserv = observer(({discipline_id, age_group_id, distiplineSelectFull}) => {
    const store = useStore()

    const [forceUpdate, setForceUpdate] = useState(false)
    const [number, setNumber] = useState(null)
    const [visualPdf, setVisualPdf] = useState(false)
    const [visualExcel, setVisualExcel] = useState(false)
    const [visualVariant, setVisualVariant] = useState(false)
    const [visualChoose, setVisualChoose] = useState(false)
    const [enabled, setEnabled] = useState(false)

    const setReserv = async () => {
        setVisualChoose(true);

        if (number !== null) {
            await store.distipline_settings.setReserv(() => {
                setForceUpdate(true)
                setTimeout(() => setForceUpdate(false), 100)
            }, age_group_id, discipline_id, number, distiplineSelectFull?.discipline_stage_id)
        } else {
            toast.error("Не верный вариант!")
        }
        setVisualChoose(false);
    }
    const downloadLinkReserve = async (type) => {
        if (type === 'PDF') {
            setVisualPdf(true);
        } else {
            setVisualExcel(true);
        }

        await store.distipline_settings.downloadLinkReserv(age_group_id, discipline_id, distiplineSelectFull?.discipline_stage_id, type)

        if (type === 'PDF') {
            setVisualPdf(false);
        } else {
            setVisualExcel(false);
        }
    }
    const createReserve = async () => {
        setVisualVariant(true);
        const status = await store.distipline_settings.createReserv(age_group_id, discipline_id, distiplineSelectFull?.discipline_stage_id)
        if (status) {
            setNumber(null);
            setEnabled(true)
        }
        setVisualVariant(false);
    }

    useEffect(() => {
        setForceUpdate(true)

        setTimeout(() => setForceUpdate(false), 100)
    }, [discipline_id, age_group_id, distiplineSelectFull])

    return (
        <>
            <div className={s.content}>
                {/*<div className={s.content_start}>V Авто</div>*/}
                <div className={s.content_end}>
                    <div className={s.content_center}>
                        {/*<div className={s.content_center_random} onClick={createReserve}>Сформировать 5 вариантов</div>*/}
                        <button style={{border: "none"}} disabled={visualVariant} className={s.content_center_random}
                                onClick={createReserve}>
                            {visualVariant &&
                                <CircularProgress style={{position: "absolute", marginLeft: "250px", marginTop: "17px"}}
                                                  size="12px" color="inherit"/>}
                            Сформировать 5 вариантов
                        </button>
                        <button style={{marginLeft: '60px'}} disabled={visualPdf} className={s.content_center_download}
                                onClick={() => {
                                    downloadLinkReserve("PDF").then(r => {
                                    })
                                }}>
                            {visualPdf &&
                                <CircularProgress style={{position: "absolute", marginLeft: "130px", marginTop: "17px"}}
                                                  size="12px" color="inherit"/>}
                            Скачать PDF
                        </button>
                        <button style={{marginRight: '60px', marginLeft: '0px'}} disabled={visualExcel}
                                className={s.content_center_download}
                                onClick={() => {
                                    downloadLinkReserve("EXCEL").then(r => {
                                    })
                                }}>
                            {visualExcel &&
                                <CircularProgress style={{position: "absolute", marginLeft: "140px", marginTop: "17px"}}
                                                  size="12px" color="inherit"/>}
                            Скачать Excel
                        </button>
                        <div>Номер жеребьёвки</div>
                    </div>
                    <div className={s.selectWrapper}>
                        <select
                            className={s.list}
                            style={{marginLeft: '10px'}}
                            value={number ?? ''}
                            disabled={!enabled}
                            onChange={(e) => setNumber(Number(e.target.value) || null)}
                        >

                            {enabled && (
                                <option value="" disabled>
                                    ---
                                </option>
                            )}

                            {!enabled && number != null && number >= 1 && number <= 5 && (
                                <option value={number}>{number}</option>
                            )}

                            {enabled &&
                                [1, 2, 3, 4, 5].map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                        </select>
                        {number === 100 && <span style={{position: "absolute", top: '20%', right: '45%', color: 'rgba(0, 0, 0, 0.7)'}}>❌</span>}
                        {number === 100 && (
                            <div className={s.tooltipHover}>
                                Сформируйте 5 вариантов!
                            </div>
                        )}
                    </div>
                    <button style={{border: "none"}} disabled={visualChoose} className={s.content_center_random}
                            onClick={setReserv}>
                        {visualChoose &&
                            <CircularProgress style={{position: "absolute", marginLeft: "95px", marginTop: "17px"}}
                                              size="12px" color="inherit"/>}
                        Выбрать
                    </button>
                </div>
            </div>

            {!forceUpdate && <SettingReserv discipline_id={discipline_id} age_group_id={age_group_id}
                                            distiplineSelectFull={distiplineSelectFull} setNumber={setNumber}
                                            setEnabled={setEnabled}/>}
        </>

    );
});

export default Reserv;
